<div mat-dialog-content>
  @if (serverInfo) {
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <p class="list-inline-item font-weight-bold text-uppercase">
            v{{serverInfo.version}}
          </p>
          @if (serverInfo.isOkay) {
<p style="position: absolute;
                top: 0px;
                right: 0px;">
              Server Responsive
              <mat-icon style="color: green;">check</mat-icon>
            </p>
          } @else {
          <p style="position: absolute;
                  top: 0px;
                  right: 0px;">
              Server Unresponsive
              <mat-icon style="color: red;">close</mat-icon>
            </p>
          }
        </mat-card-title>
        <mat-card-subtitle class="group-dialog-box">
          - {{serverInfo.versionDbSchemaLastMigrationInDb}} <br>
          - {{serverInfo.versionDbSchemaLastMigrationInConfig}} <br>
          - {{serverInfo.versionDescription}}
        </mat-card-subtitle>
      </mat-card-header>
    </mat-card>
  }
</div>
<div mat-dialog-actions>
  <button mat-button color="primary" (click)="onNoClick()">Okay</button>
</div>